import React from 'react'
import './portfolio.css'
import IMG1 from '../../assets/portfolio1.png'
import IMG2 from '../../assets/portfolio2.jpg'
import IMG3 from '../../assets/portfolio3.jpg'

const data = [
  {
    id: 1,
    image: IMG1,
    title: 'Responsive Admin Dashboard for E-commerce',
    description: 'Fully responsive admin dashboard built with HTML, CSS, and JavaScript. Features light and dark mode theme switching using CSS Variables, Grid, and Flexbox layouts with media queries. Demonstrates responsive design principles, modern CSS techniques, and attention to user interface design for operational dashboards.',
    github: 'https://github.com/apurvachoudhari/admin-dashboard',
    demo: 'https://youtu.be/1c7QXWxMrxU'
  },
  {
    id: 2,
    image: IMG2,
    title: 'Learning Portal',
    description: 'Course delivery and learning platform interface demonstrating user-centric design for educational content. Shows ability to create intuitive interfaces that support user onboarding and feature discoverability for learning outcomes.',
    github: 'https://github.com/apurvachoudhari/learning-portal',
    demo: 'https://youtu.be/2zlku11Gcf8'
  },
  {
    id: 3,
    image: IMG3,
    title: 'Movie Recommendation Engine',
    description: 'Full-stack Python Flask web application implementing a content-based recommendation system. Analyzes movie attributes (genre, cast, director, storyline) to recommend similar movies based on user input. Demonstrates backend algorithm development, data processing, and user interface integration for data-driven recommendations.',
    github: 'https://github.com/apurvachoudhari/movie-recommendation-engine',
    demo: 'https://youtu.be/6VUMjsLF_tM'
  }
]

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className='container portfolio__container'>
        {
          data.map(({id, image, title, description, github, demo}) => {
            return(
              <article className='portfolio__item'>
              <div className='portfolio__item-image'>
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <p className='portfolio__item-description'>{description}</p>
              <div className="portfolio__item-cta">
                <a href={github} className='btn' target='_blank'>Github</a>
                <a href={demo} className='btn btn-primary' target='_blank'>Live Demo</a>
              </div>
            </article>
            )
        } )
      }      
        
      </div>
    </section>
  )
}

export default Portfolio